import React from "react";
import footer from "../css/footer.css";
import footer_logo from "./Assets/logo_big.png";
import instagram_icon from "./Assets/instagram_icon.png";
import pinterester_icon from "./Assets/pintester_icon.png";
import whatsapp_icon from "./Assets/whatsapp_icon.png";
import {Link} from "react-router-dom";

const Footer = () => {
  return (
    <div style={footer} className="footer">
      <Link to={"/"} className="Link logo">
        <div className="footer-logo">
          <img src={footer_logo} alt="Footer description" />
          <p>SHOPPER</p>
        </div>
      </Link>
      <ul className="footer-links">
        <li>Company</li>
        <li>Products</li>
        <li>Offices</li>
        <li>About</li>
        <li>Contact</li>
      </ul>
      <div className="footer-social-icon">
        <div className="footer-icons-container">
          <img src={instagram_icon} alt="instagram" />
        </div>
        <div className="footer-icons-container">
          <img src={pinterester_icon} alt="pinterest" />
        </div>
        <div className="footer-icons-container">
          <img src={whatsapp_icon} alt="whatsapp" />
        </div>
      </div>
      <div className="footer-copyright">
        <hr />
        <p>&copy; copyright 2023 - All Rights Reserved</p>
      </div>
    </div>
  );
};

export default Footer;
